module.exports = __webpack_public_path__ + "static/media/Story-PS-TeacherMap-svg.956bff11.svg";